import React from 'react'
import PropTypes from 'prop-types'
import Box from '../Box'

const Tag = (props) => {
  const { boxProps, children } = props
  return (
    <Box
      color="bodyFontLightColor"
      fontSize="xxsmall"
      letterSpacing="0.5px"
      marginRight="small"
      padding="small"
      variant="whiteGrey"
      width="auto"
      {...boxProps}
    >
      {children}
    </Box>
  )
}

Tag.propTypes = {
  boxProps: PropTypes.object,
  children: PropTypes.node,
}
export default Tag